import PropsProxyDirective from '../extensions/PropsProxyDirective';

import star0 from '../../assets/svg/star0.svg';
import star1 from '../../assets/svg/star1.svg';
import star2 from '../../assets/svg/star2.svg';
import star3 from '../../assets/svg/star3.svg';
import star4 from '../../assets/svg/star4.svg';
import star5 from '../../assets/svg/star5.svg';
import unfold from '../../assets/svg/unfold.svg';
import fold from '../../assets/svg/fold.svg';
import lightning from '../../assets/svg/lightning.svg';

const nameToIcon = {
	star0,
	star1,
	star2,
	star3,
	star4,
	star5,
	unfold,
	fold,
	lightning,
};

export default {
	directives: {
		Proxy: PropsProxyDirective,
	},

	props: {
		name: {
			type: String,
			required: true,
		},

		width: {
			type: [Number, String],
		},

		height: {
			type: [String, Number],
		},

		fill: {
			type: String,
		},
	},

	render(h) {
		return h('span', {
			domProps: {
				innerHTML: nameToIcon[this.name],
			},

			attrs: {
				width: this.width,
				height: this.height,
				fill: this.fill,
			},

			directives: [{name: 'proxy', value: this.name}],
		});
	},
}
